import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'
import Switch, { Case } from 'react-switch-case';
import { withRouter } from "react-router-dom";

// import other components within the same project here
import API from "composer/tools/API.jsx"

import LoginPage from "composer/pages/LoginPage.jsx";
import TopBar from "composer/views/TopBar.jsx";
import ConfirmDialog from "composer/views/ConfirmDialog.jsx"
import Notification from "composer/views/Notification.jsx"
import LocaleViewerPage from "composer/pages/LocaleViewerPage.jsx"
import StageViewerPage  from "composer/pages/StageViewerPage.jsx"
import RetrieverPage from "composer/pages/RetrieverPage.jsx"
import HeatmapPage from "composer/pages/HeatmapPage.jsx"

import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { indigo, pink } from '@material-ui/core/colors';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: indigo[500],
    },
    secondary: {
      main: pink["A400"],
    },
  },
  typography: {
    fontFamily: [
      "Roboto",
      "Noto Sans TC",
    ].join(','),
  },
});

const keys = [];
let previousKey;

const STATUS_REQUIRE_LOGIN = -1;
const STATUS_VIEW_LOCALE_LIST = 0;
const STATUS_VIEW_LOCALE_STAGE = 1;
const STATUS_VIEW_RETRIEVER = 2;
const STATUS_VIEW_HEATMAP = 3;

class RootPage extends React.Component {
  STATUS_REQUIRE_LOGIN() {
    return STATUS_REQUIRE_LOGIN;
  }

  STATUS_VIEW_LOCALE_LIST() {
    return STATUS_VIEW_LOCALE_LIST;
  }

  STATUS_VIEW_LOCALE_STAGE() {
    return STATUS_VIEW_LOCALE_STAGE;
  }

  STATUS_VIEW_RETRIEVER() {
    return STATUS_VIEW_RETRIEVER;
  }

  STATUS_VIEW_HEATMAP() {
    return STATUS_VIEW_HEATMAP;
  }

  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      status: STATUS_REQUIRE_LOGIN,
      canUpload: true,
      userData: {},
      userRoleData: {},
      targetLocaleData: {},
    };
    autoBind(this);
  }

  componentWillMount(){
    this.props.history.listen(this.historyOnChange);
  }

  historyOnChange(location) {
    const { key } = location;
    let goBack = false;
    // If there is no key, it was a goBack.
    if (key === undefined) {
      goBack = true;
      //return;
    }
    // If it's an entirely new key, it was a goForward.
    // If it was neither of the above, you can compare the index
    // of `key` to the previous key in your keys array.
    if (!keys.includes(key)) {
      keys.push(key);
    } else if (keys.indexOf(key) < keys.indexOf(previousKey)) {
      goBack = true;
    }
    previousKey = key;

    let path = this.props.history.location.pathname;
    if (this.props.history.action === "POP") {
      if (this.state.status == STATUS_VIEW_RETRIEVER) {
        if (goBack) {
          this.refs.retrieverPage.handleBackButtonClicked();
        }
        else {
          this.refs.retrieverPage.handleForwardButtonClicked();
        }
      }
      else if (this.state.status == STATUS_VIEW_HEATMAP) {
        if (goBack) {
          this.refs.heatmapPage.handleBackButtonClicked();
        }
        else {
          this.refs.heatmapPage.handleForwardButtonClicked();
        }
      }
      else if (this.state.status == STATUS_VIEW_LOCALE_STAGE) {
        if (goBack) {
          this.refs.stageViewerPage.handleBackButtonClicked();
        }
      }
      else if (this.state.status == STATUS_VIEW_LOCALE_LIST) {
        if (path === "/locale/stage") {
          this.refs.localeViewerPage.editLocale(this.props.history.location.state.locale, false);
        }
        else if (path === "/locale/heatmap") {
          this.refs.localeViewerPage.retrieveHeatmap(this.props.history.location.state.locale, false)
        }
        else if (path === "/locale/retriever") {
          this.refs.localeViewerPage.retrieveAnswer(this.props.history.location.state.locale, false)
        }
      }
    }
    else if (this.props.history.action === "PUSH") {

    }
  }

  pushHistory(path, object=null) {
    this.props.history.push(path, object);
  }

  goBackHistory() {
    this.props.history.goBack();
  }

  replaceHistory(path) {
    this.props.history.replace(path);
  }

  loginOK(userData) {
    this.setState({
      userData: userData,
      userRoleData: {
        id: userData['id'],
        role: userData['role'],
        same_school_view: userData['same_school_view'],
        same_school_edit: userData['same_school_edit'],
        all_school_view:  userData['all_school_view'],
        all_school_edit:  userData['all_school_edit'],
        account_disabled: Math.max(parseInt(userData['user_disabled']), parseInt(userData['school_disabled'])),
        account_subscription_date_start: userData['user_subscription']['date_start'] != null ? userData['user_subscription']['date_start'] : '',
        account_subscription_date_end: userData['user_subscription']['date_end'] != null ? userData['user_subscription']['date_end'] : '',
        account_subscription_days_left: userData['user_subscription']['date_end'] != null ? (Date.parse(userData['user_subscription']['date_end']) - Date.parse(userData['user_subscription']['date_current']))/1000/60/60/24 : '',
      }
    });
    this.changeStatus(STATUS_VIEW_LOCALE_LIST);
    this.pushHistory("/locale");
  }

  logout() {
    this.setState({
      userData: {},
      userRoleData: {},
    });
    this.changeStatus(STATUS_REQUIRE_LOGIN);

    this.replaceHistory("/");
  }

  enableUpload(){
    this.setState({ canUpload: true });
  }

  disableUpload(){
    this.setState({ canUpload: false });
  }

  changeStatus(newStatus) {
    this.setState({
      status: newStatus
    });
    this.state.status = newStatus;

    if (this.refs.localeViewerPage != null) {
      this.refs.localeViewerPage.setState({ active: (newStatus == STATUS_VIEW_LOCALE_LIST) });
    }
  }

  addNotification(message) {
    this.refs.notification.add(message);
  }

  languageChanged() {
    this.forceUpdate();
  }

  render() {
    return (
      <ThemeProvider theme={theme}>
        <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Noto+Sans+TC:300,400,500,700&display=swap" />
        <div>
          <API root={this} parent={this} ref="API"/>
          <ConfirmDialog root={this} parent={this} ref="confirmDialog"/>
          <Notification root={this} parent={this} ref="notification"/>

          <If condition={this.state.status != STATUS_REQUIRE_LOGIN}>
            <Then>
              <TopBar root={this} parent={this}/>
              <LocaleViewerPage root={this} parent={this} ref="localeViewerPage"/>
            </Then>
          </If>
          <Switch condition={this.state.status}>
            <Case value={STATUS_REQUIRE_LOGIN}>
              <LoginPage root={this} parent={this}/>
            </Case>
            <Case value={STATUS_VIEW_LOCALE_STAGE}>
              <StageViewerPage root={this} parent={this} ref="stageViewerPage"
                localeData={this.state.targetLocaleData}
              />
            </Case>
            <Case value={STATUS_VIEW_RETRIEVER}>
              <RetrieverPage root={this} parent={this} ref="retrieverPage"
                localeData={this.state.targetLocaleData}
              />
            </Case>
            <Case value={STATUS_VIEW_HEATMAP}>
              <HeatmapPage root={this} parent={this} ref="heatmapPage"
                localeData={this.state.targetLocaleData}
              />
            </Case>
          </Switch>
        </div>
      </ThemeProvider>
    )
  }

  // list of common functions used by different components in the Apps

  getMyUserData(){
    return this.state.userData;
  }

  getMyUserRoleData(){
    return this.state.userRoleData;
  }

  // data functions
  getMyUserId(){
    return this.getMyUserData()['id'];
  }
  getOriginalUserId(){
    return this.getMyUserRoleData()['id'];
  }
  getMySchoolId(){
    return this.getMyUserData()['school_id'];
  }

  // role and privilege
  getMyUserRole() {
    return this.getMyUserData()['role'];
  }

  getOriginalUserRole() {
    return this.getMyUserRoleData()['role'];
  }
  getSameSchoolView() {
    return this.getMyUserRoleData()['same_school_view'];
  }
  getSameSchoolEdit() {
    return this.getMyUserRoleData()['same_school_edit'];
  }
  getAllSchoolView() {
    return this.getMyUserRoleData()['all_school_view'];
  }
  getAllSchoolEdit() {
    return this.getMyUserRoleData()['all_school_edit'];
  }

  getAccountDisabled(){
    return this.getMyUserRoleData()['account_disabled'];
  }

  getAccountStartDate(){
    return this.getMyUserRoleData()['account_subscription_date_start'];
  }

  getAccountExpiryDate(){
    return this.getMyUserRoleData()['account_subscription_date_end'];
  }

  getAccountSubscriptionDaysLeft(){
    console.log('account_subscription_days_left:' + this.getMyUserRoleData()['account_subscription_days_left']);
    return this.getMyUserRoleData()['account_subscription_days_left'];
  }

  isAdminUser() {
    return (this.getMySchoolId() == 1097 && this.getMyUserRole() == 3);
  }

  getUserDataById(userId){
    this.refs.API.request("get_user_data_by_id", {user_id: userId}, this.getUserDataOK, this.getUserDataFailed);
  }

  getUserDataOK(res){
    this.setState({userData: res.body['result']});
    this.state.userData = res.body['result'];
  }

  getUserDataFailed(err){
    console.log("getUserDataFailed");
  }

  getLoginInfo(){
    this.refs.API.request("get_login_info", {}, this.getLoginInfoOK, this.getLoginInfoFailed);
  }

  getLoginInfoOK(res){
    console.log("getLoginInfoOK");
  }

  getLoginInfoFailed(res){
    console.log("getLoginInfoFailed");
    console.log(res);
  }

  showStorageQuotaDialog(confirmCallback, cancelCallback) {
    let dialogText = {
      title: "Insufficent storage quota",
      content: "File upload or creating new VITALS is suspended.",
    }
    this.refs.confirmDialog.show(dialogText, confirmCallback, cancelCallback);
  }

  emptyFunction() {
    
  }
}

const withRouterAndRef = Wrapped => {
  const WithRouter = withRouter(({ forwardRef, ...otherProps }) => (
    <Wrapped ref={forwardRef} {...otherProps} />
  ))
  const WithRouterAndRef = React.forwardRef((props, ref) => (
    <WithRouter {...props} forwardRef={ref} />
  ))
  const name = Wrapped.displayName || Wrapped.name
  WithRouterAndRef.displayName = `withRouterAndRef(${name})`
  return WithRouterAndRef
}

export default withRouterAndRef(RootPage);
